export const SHOW_DETAILS = [
	{ id: 'dataset-title', label: 'Dataset Title', text: '', value: '', selected: true, error: false },
	{ id: 'time-stamp', label: 'Time Stamp', text: 'Last Refreshed', selected: true },
	{ id: 'id-stamp', label: 'ID Stamp', text: 'Refreshed by', selected: true },
];
